var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPullUpChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 7,
    viewBox: "0 0 35 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7896 0.094512C32.8221 -0.188621 33.9773 0.185865 34.3696 0.93095C34.762 1.67603 34.243 2.50957 33.2105 2.7927L18.2105 6.90588C17.7528 7.03137 17.2473 7.03137 16.7896 6.90588L1.78962 2.7927C0.757082 2.50957 0.238122 1.67603 0.630486 0.93095C1.02285 0.185865 2.17796 -0.188621 3.21049 0.094512L17.5001 4.01288L31.7896 0.094512Z",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPullUpChevron);
export default __webpack_public_path__ + "static/media/pull-up-chevron.5ecf21e3d40b33d56c91210bf9ea6329.svg";
export { ForwardRef as ReactComponent };